import emailjs from 'emailjs-com';

/**
 * Send an email using EmailJS.
 * Requires these environment variables to be set in your React app:
 * REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, REACT_APP_EMAILJS_PUBLIC_KEY
 *
 * The EmailJS template should be configured in your EmailJS account. A template can use
 * variables like: from_name, reply_to, message, and any other fields you include here.
 *
 * @param {Object} templateParams - object with template fields (from_name, reply_to, message...)
 * @returns {Promise} resolves when email is sent
 */
export function sendEmail(templateParams) {
	const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
	const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
	const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY; // formerly user ID

	if (!serviceId || !templateId || !publicKey) {
		return Promise.reject(new Error('EmailJS is not configured. Set REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID and REACT_APP_EMAILJS_PUBLIC_KEY.'));
	}
	return emailjs.send(serviceId, templateId, templateParams, publicKey);
}

export default sendEmail;
